<template>
    <div class="main-header-con">
        <div class="main-header">
            <div class="head-content">
                <div class="header-left">
                    <template v-if="channel == 'sy'">
                        <img :src="`${logoPath}?${timestamp}`" class="sy-img" />
                        <span class="sy-title">{{ logoTitle }}数据看板</span>
                    </template>
                    <template v-else>
                        <img :src="`${logoPath}?${timestamp}`" width="100%" height="100%" />
                    </template>
                </div>
            </div>
            <div class="nav-con">
                <div class="nav-main">
                    <breadcrumb-nav :currentPath="currentPath"></breadcrumb-nav>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapGetters
} from 'vuex'
import breadcrumbNav from "../components/breadcrumbNav.vue";

export default {
    name: "table-top-header",
    computed: {
        ...mapGetters([
            'schoolName'
        ]),
        currentPath() {
            return this.$store.getters.currentPath; // 当前面包屑数组
        }
    },
    components: {
        breadcrumbNav
    },
    data() {
        return {
            theme1: "primary",
            channel: process.env.VUE_APP_CHANNEL,
            logoPath: process.env.VUE_APP_TABLE_LOGO_PATH,
            logoTitle: process.env.VUE_APP_LOGO_TITLE,
            timestamp: (new Date()).getTime()
        }
    },
    methods: {
        selectMenuStats(menuType) {
            this.$router.push({
                name: menuType
            });
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../style/detailPage";

.header-left {
    display: flex;
    align-items: center;
}

.sy-img {
    width: 50px;
    height: 50px;
}

.sy-title {
    font-size: 16px;
    font-weight: bold;
}
</style>
<style lang="scss">
@import "../style/detailPage";

.nav-main .ivu-breadcrumb-item-separator {
    margin: unset;
}

.ivu-page-item-active {
    border-color: #00b49c;
    background: #00caaf;
}

.ivu-breadcrumb {
    color: unset;
    font-size: vw(14)
}

.ivu-page-item:hover {
    border-color: #00caaf;
}

.ivu-page-item-active a {
    color: #fff;
}

.ivu-page-item-active:hover a {
    color: #fff !important;
}

.ivu-page-item:hover a {
    color: #00caaf;
}

.ivu-page-next:hover,
.ivu-page-prev:hover {
    border-color: #00caaf;
}

.ivu-page-next:hover a,
.ivu-page-prev:hover a {
    color: #00caaf;
}

a {
    color: #00caaf;
}

a:hover {
    color: #00caaf;
}
</style>
